module.exports = __webpack_public_path__ + "h5/img/logo.f5b4a1c5.png";